export const areFieldsVisible = (
	fieldsToCheckVisibility,
	companyFields: Array<{ name: string; tags: string[]; type: string; visibleTo: string[] }> = [],
	userPermissions: string[]
) => {
	const result = {};
	fieldsToCheckVisibility.forEach((fieldItem) => {
		const foundItem = companyFields?.find((field) => field?.name === fieldItem.lookup);
		if (foundItem) {
			const canView = foundItem?.visibleTo?.some((role) => userPermissions.includes(role));
			result[fieldItem.name] = canView;
		} else {
			result[fieldItem.name] = false;
		}
	});
	return result;
};
